export const APPLICATION_PROCESS_2_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    meta_description:
      "Fill your details and complete your application.",
    meta_priority: 1,
  },

  METADATA_TITLES: {
    metadata_2: "Admission steps",
  },

  APPLICATION_PROCESS_FIELDS_CONFIG: [
    {
      fieldName: "background_image",
      label: "Section background image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "",
      description: "Full-bleed background for the section (no color overlay).",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "alt_background_image",
      label: "Alt text — background image",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "title",
      label: "Headline",
      value: "Our Admission process",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Wrap words in { } to highlight — Our {Admission} process",
      description:
        "Wrap words in { } to colour them with the highlight colour below. Use {{ }} to also break the line after the highlight.",
      required: false,
      defaultValue: "Our Admission process",
    },
    {
      fieldName: "title_start_color",
      label: "Headline color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "title_highlight_color",
      label: "Headline highlight color",
      value: "#FF6B00",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Color of the words wrapped in { }",
      required: false,
      defaultValue: "#FF6B00",
    },
    {
      fieldName: "subtitle_1",
      label: "Sub-headline",
      value:
        "Complete your application and enrol in the program with four easy steps!",
      valueType: "string",
      filedType: "TEXTAREA",
      placeholder: "",
      required: false,
      defaultValue:
        "Complete your application and enrol in the program with four easy steps!",
      rows: 3,
    },
    {
      fieldName: "subtitle_1_color",
      label: "Sub-headline color",
      value: "#F3F4F6",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "",
      required: false,
      defaultValue: "#F3F4F6",
    },
    {
      fieldName: "cta_label",
      label: "Primary CTA label",
      value: "Apply Now",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "",
      required: false,
      defaultValue: "Apply Now",
    },
    {
      fieldName: "accent_color",
      label: "Accent (CTA & step numbers)",
      value: "#FF6B00",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "",
      required: false,
      defaultValue: "#FF6B00",
    },
    {
      fieldName: "cta_link",
      label: "Primary CTA URL (Apply Now)",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "/apply or https://… (used when Is CTA is off)",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "cta_is_cta",
      label: "Is CTA — Primary (lead popup)",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder:
        "On = lead capture popup; off = open Primary CTA URL above",
      required: false,
      defaultValue: true,
    },
    {
      fieldName: "status",
      label: "Section status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "",
      defaultValue: true,
    },
  ],

  METADATA_FIELDS_2: [
    {
      header: "Step copy",
      fieldName: "meta_description",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Step description",
      required: true,
      rows: 2,
    },
    {
      header: "Step order",
      fieldName: "meta_priority",
      value: "",
      valueType: "number",
      filedType: "INPUT",
      placeholder: "",
      required: true,
    },
  ],
};
